import http from '@/http'

const PATH = (id) => `/customers/${id}/contracts`

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listContracts ({customerId, params}) {
        try {
            const response = await http.get(PATH(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, contractId: number}} data
     * @returns {Promise<void>}
     */
    async showContract ({customerId, contractId}) {
        try {
            const response = await http.get(`${PATH(customerId)}/${contractId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
